import { defineMessages } from '@atlassian/jira-intl';

// Don't confuse Intl messages with `Flag`s
const messages = defineMessages({
	boardNotFound: {
		id: 'query-string-notifier.common.board-not-found',
		defaultMessage: 'Board not found',
		description: '',
	},
	boardNotFoundDescription: {
		id: 'query-string-notifier.common.board-not-found-description',
		defaultMessage:
			"You tried to access a board that doesn't exist or that you don't have permission to see.",
		description: '',
	},
	projectNotFound: {
		id: 'query-string-notifier.common.project-not-found',
		defaultMessage: 'Project not found',
		description: '',
	},
	projectNotFoundDescription: {
		id: 'query-string-notifier.common.project-not-found-description',
		defaultMessage:
			"You tried to access a project that doesn't exist or that you don't have permission to see.",
		description: '',
	},
});

export default messages;
